var _path, _path2, _path3, _path4, _g, _g2, _g3, _g4, _g5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShipmentMessagesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 385,
    height: 218,
    viewBox: "0 0 385 218",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M183.634 3.61456C249.341 -2.24495 249.447 34.8635 279.053 69.4373C308.66 104.011 314.995 119.681 303.834 159.536C292.673 199.386 255.067 230.63 208.542 212.929C162.016 195.229 135.365 212.229 106.018 196.506C76.6768 180.784 65.7803 150.415 87.2607 114.627C108.741 78.8337 102.617 10.8369 183.634 3.61456Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.364 152.493C96.7456 167.426 124.059 193.364 147.416 166.66C147.416 166.66 158.826 150.808 166.178 131.817C175.367 108.077 201.022 57.5343 247.352 106.162",
    stroke: "#053A6C",
    strokeWidth: 2,
    strokeDasharray: "6 6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M229.259 63.4095C225.98 63.4165 222.804 64.5549 220.268 66.6323C217.731 68.7097 215.989 71.5989 215.336 74.8118C214.145 73.5871 212.625 72.7338 210.959 72.3551C209.293 71.9765 207.553 72.0888 205.949 72.6784C204.346 73.268 202.948 74.3097 201.924 75.6774C200.9 77.0451 200.295 78.6802 200.181 80.3848L243.279 80.2864C243.67 78.2266 243.601 76.1058 243.077 74.0758C242.552 72.0458 241.586 70.1569 240.246 68.5442C238.906 66.9315 237.226 65.6349 235.327 64.7472C233.427 63.8596 231.355 63.4027 229.259 63.4095Z",
    fill: "#E5EDF0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M127.25 131.717C130.271 131.725 133.197 132.774 135.535 134.688C137.872 136.602 139.478 139.264 140.081 142.225C141.178 141.096 142.578 140.309 144.113 139.96C145.648 139.611 147.251 139.714 148.728 140.257C150.206 140.801 151.494 141.761 152.437 143.021C153.38 144.281 153.937 145.788 154.042 147.358L114.333 147.269C114.181 146.457 114.104 145.632 114.104 144.806C114.112 141.327 115.501 137.994 117.966 135.539C120.432 133.085 123.771 131.71 127.25 131.717Z",
    fill: "#E5EDF0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_642_14421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.81 73.976L347.006 84.8713C348.34 84.9964 349.334 86.1926 349.208 87.5277L341.997 164.44L220.937 153.089L228.149 76.1764C228.274 74.8443 229.473 73.8506 230.81 73.976Z",
    fill: "#F7FAFF",
    stroke: "#053A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.725 149.803L233.336 79.3016L343.658 89.6461L337.048 160.147L226.725 149.803Z",
    fill: "#F7FAFF",
    stroke: "#053A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.851 173.438L206.43 159.521L199.359 156.148L362.429 171.438L354.851 173.438Z",
    fill: "#0062FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.077 81.9843C289.05 82.27 288.798 82.4792 288.509 82.4522C288.22 82.4251 288.011 82.1725 288.038 81.8868C288.064 81.6012 288.32 81.3891 288.606 81.4159C288.892 81.4427 289.104 81.6956 289.077 81.9843Z",
    fill: "#87888A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.987 159.903L270.717 157.909L270.451 160.749L291.721 162.743L291.987 159.903Z",
    fill: "#F7FAFF",
    stroke: "#F7FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.793 161.301L292.838 160.823L362.312 167.337L361.978 170.894L199.904 155.697L200.237 152.14L269.629 158.647L269.584 159.124C269.495 160.07 270.195 160.916 271.14 161.005L290.915 162.859C291.859 162.948 292.704 162.247 292.793 161.301Z",
    fill: "#F7FAFF",
    stroke: "#053A6C"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_642_14421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.695 170.682L118.226 155.298C116.788 146.657 120.52 141.402 124.144 136.298L124.162 136.273C127.784 131.172 131.29 126.218 129.93 118.007L11.3417 140.112C13.0313 148.261 18.0868 151.62 23.3029 155.073L23.3289 155.09C28.5488 158.545 33.9231 162.103 35.695 170.682Z",
    fill: "#F7FAFF",
    stroke: "#053A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.128 111.858L123.847 109.114L125.251 116.649L110.532 119.393L109.128 111.858Z",
    fill: "#DAE9FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.413 102.659L122.132 99.9153L123.537 107.45L108.818 110.194L107.413 102.659Z",
    fill: "#DAE9FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7189 114.916L107.438 112.173L108.842 119.707L94.1234 122.451L92.7189 114.916Z",
    fill: "#DAE9FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0043 105.718L105.723 102.974L107.128 110.509L92.4088 113.253L91.0043 105.718Z",
    fill: "#DAE9FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3131 117.974L91.0321 115.231L92.4366 122.766L77.7176 125.509L76.3131 117.974Z",
    fill: "#DAE9FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5985 108.776L89.3175 106.032L90.722 113.567L76.003 116.31L74.5985 108.776Z",
    fill: "#DAE9FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2897 96.519L104.009 93.7754L105.413 101.31L90.6942 104.054L89.2897 96.519Z",
    fill: "#DAE9FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8839 99.5771L87.6029 96.8335L89.0074 104.368L74.2884 107.112L72.8839 99.5771Z",
    fill: "#DAE9FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9042 121.033L74.6233 118.289L76.0278 125.824L61.3087 128.568L59.9042 121.033Z",
    fill: "#DAE9FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1895 111.834L72.9086 109.091L74.3131 116.626L59.594 119.369L58.1895 111.834Z",
    fill: "#DAE9FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9678 132.081L45.4116 113.003L21.3732 117.484L24.9294 136.562L48.9678 132.081Z",
    fill: "#F7FAFF",
    stroke: "#053A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5687 132.211L47.805 131.723L47.8435 131.929L25.2995 136.132L24.5687 132.211Z",
    fill: "#0062FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6837 113.695L39.8689 103.959L34.1046 105.033L35.9194 114.77L41.6837 113.695Z",
    fill: "#F7FAFF",
    stroke: "#053A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8643 115.712L29.0494 105.975L23.2851 107.05L25.1 116.786L30.8643 115.712Z",
    fill: "#F7FAFF",
    stroke: "#053A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1345 113.287L42.0841 113.115L35.3368 114.373L35.1345 113.287Z",
    fill: "#F7FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3151 115.304L31.2648 115.131L24.5174 116.389L24.3151 115.304Z",
    fill: "#F7FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2993 171.287L118.819 155.719L119.459 159.15L35.9388 174.718L35.2993 171.287Z",
    fill: "#0062FF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_642_14421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.969 40.7476V48.7216",
    stroke: "#FFDA58",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.468 48.823L369.828 54.4633",
    stroke: "#FFDA58",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.544 68.3225H375.57",
    stroke: "#FFDA58",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.475 48.823L342.11 54.4633",
    stroke: "#FFDA58",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_642_14421)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M356.625 66.2515H289.246C283.331 66.2515 278.538 71.0443 278.538 76.9591V133.78L290.332 123.634H356.625C362.54 123.634 367.333 118.841 367.333 112.926V76.9591C367.333 71.0443 362.54 66.2515 356.625 66.2515Z",
    fill: "url(#paint0_linear_642_14421)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.625 66.2515H289.246C283.331 66.2515 278.538 71.0443 278.538 76.9591V133.78L290.332 123.634H356.625C362.54 123.634 367.333 118.841 367.333 112.926V76.9591C367.333 71.0443 362.54 66.2515 356.625 66.2515Z",
    stroke: "url(#paint1_linear_642_14421)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_642_14421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.538 72.8469H295.173C291.919 72.8469 289.282 75.4844 289.282 78.7379V111.082C289.282 114.335 291.919 116.973 295.173 116.973H350.538C353.791 116.973 356.429 114.335 356.429 111.082V78.7379C356.429 75.4844 353.791 72.8469 350.538 72.8469Z",
    fill: "url(#paint2_linear_642_14421)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.172 72.8469H298.808C295.554 72.8469 292.917 75.4844 292.917 78.7379V111.082C292.917 114.335 295.554 116.973 298.808 116.973H354.172C357.426 116.973 360.063 114.335 360.063 111.082V78.7379C360.063 75.4844 357.426 72.8469 354.172 72.8469Z",
    fill: "url(#paint3_linear_642_14421)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.49 90.7944L294.618 115.648C295.525 116.465 296.725 116.973 298.05 116.973H354.942C356.261 116.973 357.461 116.471 358.374 115.648L326.496 90.7944H326.49Z",
    fill: "url(#paint4_linear_642_14421)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.49 99.0252L358.368 74.172C357.461 73.3543 356.261 72.8469 354.936 72.8469H298.044C296.725 72.8469 295.525 73.3483 294.612 74.172L326.49 99.0252Z",
    fill: "url(#paint5_linear_642_14421)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.618 74.1719L326.49 99.0251L358.368 74.1719",
    stroke: "#CC5833",
    strokeWidth: 1.44,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.778 82.1537C368.918 77.0141 368.918 68.6812 363.778 63.5416C358.638 58.402 350.306 58.402 345.166 63.5416C340.026 68.6812 340.026 77.0141 345.166 82.1537C350.306 87.2933 358.638 87.2933 363.778 82.1537Z",
    fill: "#D4003C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.503 82.1532C370.643 77.0136 370.643 68.6807 365.503 63.5411C360.364 58.4015 352.031 58.4015 346.891 63.5411C341.752 68.6807 341.752 77.0136 346.891 82.1532C352.031 87.2928 360.364 87.2928 365.503 82.1532Z",
    fill: "#FF335B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.24 79.4004H356.703V68.5554L354.322 68.6151V66.6693L359.24 66.168V79.4004Z",
    fill: "#D4003C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.058 79.4003H355.545V68.6568L353.188 68.7165V66.7886L358.058 66.2932V79.4003Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_642_14421",
    x1: 278.538,
    y1: 100.016,
    x2: 367.333,
    y2: 100.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#C5EEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_642_14421",
    x1: 284.74,
    y1: 65.4815,
    x2: 352.4,
    y2: 133.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1697D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ADECE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_642_14421",
    x1: 326.58,
    y1: 78.7737,
    x2: 315.657,
    y2: 126.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F88C57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#D55A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE5021"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_642_14421",
    x1: 326.371,
    y1: 132.515,
    x2: 326.532,
    y2: 83.3099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6DE55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#F5D354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F5B654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5AE54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_642_14421",
    x1: 317.37,
    y1: 162.955,
    x2: 328.895,
    y2: 103.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6DE55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#F5D354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F5B654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5AE54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_642_14421",
    x1: 326.711,
    y1: 67.8273,
    x2: 325.123,
    y2: 113.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6DE55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#F5D354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F5B654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5AE54"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_642_14421"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 163.786,
    height: 87.9471,
    fill: "white",
    transform: "translate(207.318 71.271) rotate(5.35676)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_642_14421"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 121.641,
    height: 101.7,
    fill: "white",
    transform: "matrix(-0.983067 0.183245 0.183245 0.983067 119.581 59.7322)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_642_14421"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 183.791,
    height: 69.5163,
    fill: "white",
    transform: "translate(200.946)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_642_14421"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 89.9886,
    height: 69.4268,
    fill: "white",
    transform: "translate(277.941 65.6545)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_642_14421"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80.0807,
    height: 57.2867,
    fill: "white",
    transform: "translate(289.282 59.686)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipmentMessagesIcon);
export default __webpack_public_path__ + "static/media/shipment-messages-icon.1bbcdaee74274af600cce3aec7c5f4a5.svg";
export { ForwardRef as ReactComponent };